import { render } from "./comparison-tool.vue?vue&type=template&id=0a1e1fea&ts=true&lang=pug"
import script from "./comparison-tool.vue?vue&type=script&setup=true&lang=ts"
export * from "./comparison-tool.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__